import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GqlSpeciesGetAutocompleteOptionsParams } from "~/__generated__";

import { SpeciesSelect_GetAutocompleteOptionsDocument } from "../queries.generated";

export default function useSpeciesSelect_GetAutocompleteOptions(params: GqlSpeciesGetAutocompleteOptionsParams) {
    const { data, previousData, loading } = useQuery(SpeciesSelect_GetAutocompleteOptionsDocument, {
        variables: { params },
    });

    const options = useMemo(() => data?.speciesGetAutocompleteOptions.data ?? [], [data]);
    const selectedOptions = useMemo(
        () => (data ?? previousData)?.speciesGetAutocompleteOptions.selectedData ?? [],
        [data, previousData],
    );

    return { options, selectedOptions, loading };
}
